import { ELandStatusType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectLandStatusFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const LandStatusContainer: FC = () => {
  const { label, value, options } = useSelector(selectLandStatusFilter);

  const onChange = useFilterChangeCallback();

  const handleLandStatusChange = useCallback(
    (newValue: NonEmptyArray<ELandStatusType> | null) => {
      onChange({ action: 'setLandStatusTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleLandStatusChange} />
    </AdvancedFilterRow>
  );
};
